import {
    FaFileCircleCheck,
    FaHandHoldingDollar,
    FaShieldHeart,
    FaBandage, FaHeartPulse, FaSyringe,
} from "react-icons/fa6";

export const stepper = [
    {
        icon: <FaHeartPulse />,
        title: "Faster Healing & Recovery",
        description:
            "Support tissue repair, collagen growth, and faster wound healing.",
        align: "bottom",
    },
    {
        icon: <FaShieldHeart />,
        title: "Ethically Sourced & Approved",
        description:
            "Quality placental grafts are ethically sourced and clinically approved.",
        align: "top",
    },
    {
        icon: <FaFileCircleCheck />,
        title: "Medicare & Medicaid Coverage",
        description:
            "Eligible graft procedures may qualify for Medicare and Medicaid coverage.",
        align: "bottom",
        featured: true,
    },
    {
        icon: <FaHandHoldingDollar />,
        title: "Expert Billing Assistance",
        description:
            "Get billing and coding support to help optimize graft reimbursement.",
        align: "top",
    },
];


export const featuresCardData = [
    {
        icon: <FaBandage />,
        title: "Chronic Wound Management",
        description:
            "Our graft supports healing of chronic wounds, including diabetic wounds.",
    },
    {
        icon: <FaSyringe />,
        title: "Post-Surgical Wound Care",
        description:
            "Support faster recovery and effective wound care after surgery.",
    },
    {
        icon: <FaHeartPulse />,
        title: "Diabetic Ulcers & Pressure Sores",
        description: "Promote healing for diabetic ulcers and pressure sores.",
    },
];